import { Input } from '@luminara/ui-components';

interface InputFieldProps {
  label: string;
  type: string;
  value?: string;
  onChange: (event: any) => any;
  id: string;
  forId: string;
  className?: string;
  readOnly?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({ label, id, forId, value = '', onChange, className, readOnly }) => {
  return (
    <div>
      <div className="relative flex flex-col focus-within mb-2">
        <Input
          type="text"
          id={id}
          value={value}
          onChange={onChange}
          className={`${
            className ? className : ''
          } peer w-input h-input py-0 m-0 placeholder:text-transparent rounded-lg active:outline-none focus:outline-none focus:ring-0`}
          readOnly={readOnly}
        />

        <label
          htmlFor={forId}
          className={`absolute transition-all text-primary-20 ${
            value?.length === 0
              ? 'left-3 top-3   text-primary-20 peer-focus-within:left-3 peer-focus-within:-top-0 peer-focus-within:primary-20 peer-focus-within:text-inputPlaceholder'
              : 'left-3 -top-0 text-primary-20 text-inputPlaceholder'
          }`}>
          {label}
        </label>
      </div>
    </div>
  );
};

export { InputField };
